var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector26(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 309,
    viewBox: "0 0 141 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.283 307.548C304.894 288.633 301.188 284.514 286.372 265.105C282.741 260.35 277.03 251.106 271.575 239.689C269.94 236.272 268.457 232.884 267.098 229.543C257.405 205.636 256.036 178.853 258.288 152.402C264.038 84.9126 227.506 24.0006 172.195 6.24336C116.789 -11.5424 55.2629 17.7177 25.241 63.378C21.335 69.3192 4.10496 97.3551 1.55799 128.115C-6.51057 225.234 87.5657 264.042 230.709 293.426C233.494 293.995 246.751 296.168 249.564 296.557L328.292 307.557L328.283 307.548Z",
    stroke: "#1E1E22",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector26);
export default __webpack_public_path__ + "static/media/vector2-6.1a36856714ccce5fb88d7413f0ccbad6.svg";
export { ForwardRef as ReactComponent };